import {useCallback} from 'react';

interface PortmoneData {
	payee_id?: string;
	order_id?: string | number;
	bill_amount?: string;
	description?: string;
	success_url?: string;
	failure_url?: string;
	lang?: string;
}

export const usePortmonePayment = () => {
	const submitPayment = useCallback((data: PortmoneData) => {
		const form = document.createElement('form');
		form.method = 'POST';
		form.action = 'https://www.portmone.com.ua/gateway/';
		form.acceptCharset = 'UTF-8';

		const fields: Record<string, string> = {
			payee_id: data.payee_id ?? '',
			shop_order_number: data.order_id?.toString() ?? '',
			bill_amount: data.bill_amount ?? '',
			description: data.description ?? '',
			success_url: data.success_url ?? '',
			failure_url: data.failure_url ?? '',
			encoding: 'UTF-8',
			exp_time: '1800',
			lang: data.lang ?? 'ua',
		};

		Object.entries(fields).forEach(([name, value]) => {
			const input = document.createElement('input');
			input.type = 'hidden';
			input.name = name;
			input.value = value;
			form.appendChild(input);
		});

		document.body.appendChild(form);
		form.submit();
	}, []);

	return {submitPayment};
};

